
import { RoundsFS } from "../../pojo/fund-strategy-export-classes";
import {HighchartsOptions} from "../../../../shared/component/highcharts-common/highcharts-global-const";

/**
 * Contains collected and calculated data for charts (not in Highcharts format)
 */
export class FsChartsData {
  barExitSize: FsExitSizeChartData[];
  barAvgInv: FsAvgInvestmentChartData[];
  barProceedsByGroup: FsProceedsByGroupChartsData[];
  pieProceedsBySize: FsProceedsBySizeChartsData[];
}

/**
 * Contains HighCharts formated data
 */
export class FsChartsOptions {
  barExitSize: Partial<HighchartsOptions>;
  barAvgInv: Partial<HighchartsOptions>;
  barProceedsByGroup: Partial<HighchartsOptions>;
  pieProceedsBySize: Partial<HighchartsOptions>;
}

/**
 * 1 Chart data - BAR - 'Exit size and holding'
 */
export class FsExitSizeChartData {
  compNumber: number;
  exitCompValue: number;
  avgInitialHolding: number;
  avgExitHolding: number;
}

/**
 * 1 Chart data - BAR - HighCharts format
 */
export class FsExitSizeMappedData {
  category: string[];
  exitCompValue: number[];
  avgInitialHolding: number[];
  avgExitHolding: number[];
}

export interface ExitSizeAggregateData {
  totalCompNumber: number;
  totalHolding: number;
  totalInitialHolding: number;
}

/**
 * 2 Chart data - BAR -  'Average Investment and Proceeds'
 */
export class FsAvgInvestmentChartData {
  compNumber: number;
  isWriteOff: boolean;
  exitCompValue: number;
  avgProceeds: number;
  avgInv: number;
  avgMoic: number;
}

/**
 * 2 Chart data - BAR - HighCharts format
 */
export class FsAvgInvestmentMappedData {
  category: string[];
  proceeds: number[];
  investment: number[];
  moic: number[];
}

export interface AvgInvestmentAggregateData {
  totalCompNumber: number;
  totalCumulativeInvestment: number;
  totalProceeds: number;
}

/**
 * 3 Chart data - BAR -  'Total Proceeds by group'
 */
export class FsProceedsByGroupChartsData {
  groupName: string;
  compNumber: number;
  sumProceeds: number;
  investment: number;
  gain: number;
}

export interface GroupProceedsAggregateData {
  groupName: string;
  totalProceeds: number;
  totalCompNumber: number;
  totalInvestment: number;
  totalGain: number;
}

/**
 * 4 Chart data - PIE -  'Total Proceeds by size'
 */
export class FsProceedsBySizeChartsData {
  compNumber: number;
  exitCompValue: number;
  sumProceeds: number;
}

export interface SizeProceedsAggregateData {
  totalCompNumber: number;
  totalProceeds: number;
}

/**
 * Aggregated data collection type for single-pass processing
 */
export interface FsChartsAggregatedData {
  exitSizeMap: Map<number, ExitSizeAggregateData>;
  avgInvestmentMap: Map<number, AvgInvestmentAggregateData>;
  groupProceedsMap: Map<string, GroupProceedsAggregateData>;
  sizeProceedsMap: Map<number, SizeProceedsAggregateData>;
  writeOffData: FsWriteOffData;
}

/**
 * Prepared sorted rounds data with initial holding
 */
export interface FsPreparedRoundsData {
  sortedRounds: RoundsFS[];
  initialHolding: number;
}

/**
 * WriteOff data for tracking total investment and companies
 */
export interface FsWriteOffData {
  totalInvestment: number;
  totalCompanies: number;
}

/**
 * 3 and 4 Chart data - PIE - HighCharts format
 */
export class FsPieMappedData {
  y: number;
  name: string;
}
